import { render, staticRenderFns } from "./moduloassegni.vue?vue&type=template&id=3b247547"
import script from "./moduloassegni.vue?vue&type=script&lang=js"
export * from "./moduloassegni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports